
// document_requests
export const GET_DOCUMENT_REQUESTS = "/document_requests";
export const ADD_NEW_DOCUMENT_REQUEST = "/document_requests";
export const UPDATE_DOCUMENT_REQUEST = "/document_requests";
export const DELETE_DOCUMENT_REQUEST = "/document_requests";


